import React from 'react';
import {HomepageSection, HomepageSectionHeader} from '../Homepage';
import ReactHighcharts from 'react-highcharts';
import PropTypes from 'prop-types';
import filter from 'App/util/common/filter';
import { process_country } from '../helper';

class GeneTherapy extends React.Component {
  render() {
    const options = {
      merge: {
        newValue: 'U',
        values: [null, 'CURR_U', 'U']
      },
      rename: {
        map: {
          'Y': 'yes',
          'N': 'no',
          'U': 'unknown'
        }
      }
    };

    const geneTherapy = filter(this.props.data, 'gene_therapy', options);
    const extData = process_country("Gene Therapy");

    const reducer = (prev, curr) => ({count: prev.count + curr.count});
    const configGeneTherapy = {
      chart: {
        type: 'column'
      },
      exporting: { enabled: false },
      title: {
        text: 'Gene Therapy'
      },
      // subtitle: {
      //   text: 'Source: WorldClimate.com'
      // },
      xAxis: {
        type: 'category'
      },
      legend: {
        enabled: false
      },
      yAxis: {
        min: 0,
        title: {
          text: 'number of patients'
        }
      },

      plotOptions: {
        series: {
          borderWidth: 0,
          dataLabels: {
            enabled: true,
            borderRadius: 2,
            y: -10,
            shape: 'callout'
          }
        }
      },
      tooltip: false,

      series: [
        {
          'name': 'Patients',
          'colorByPoint': true,
          'data':
            _(geneTherapy)
              .groupBy('gene_therapy')
              .map((objs, key) => ({
                  'name': key,
                  'y': objs.reduce(reducer).count + extData[key] ,
                })
              )
              .value()
        }
      ]
    };

    return (
      <HomepageSection style={{position: 'relative', zIndex: 2}}>
        <HomepageSectionHeader>
          <h2><span>{'Gene Therapy '}</span>
          </h2>
        </HomepageSectionHeader>
        <div className='text-center' style={{marginTop: 25, marginBottom: 25}}>
          <ReactHighcharts config={configGeneTherapy}/>
        </div>
      </HomepageSection>
    );
  }
}

GeneTherapy.propTypes = {
  data: PropTypes.array.isRequired
};

export default GeneTherapy;


// WEBPACK FOOTER //
// ./src/views/Pages/Homepage/Sections/GeneTherapy.js